import { IQ_DATA_SOURCE_ORDER, type IqDataSource } from '@/entities/iq-data-source';

/**
 * Whether a rail id names a data source rather than an ad platform. The two share the
 * `:platform` route param, so the shell needs to know which pane to mount.
 */
export const isDataSourceId = (id: string | null): id is IqDataSource =>
  id !== null && (IQ_DATA_SOURCE_ORDER as readonly string[]).includes(id);
